<template>
  <vue-slick-carousel v-if="content.length" v-bind="slickSettings" class="wordcloud-carousel" ref="carousel">
    <div v-for="slide in content" :key="slide.image_alt_text" class="slick-slide">
      <div class="app-screenshot">
        <img :src="`/assets/web-resources/techecosystem/fintech/2022/images/${slide.image_url}`" :alt="slide.image_alt_text" width="100%" />
      </div>

      <div class="app-screenshot__caption mt-15">
        <p class="text-legend text-center">{{ slide.image_alt_text }}</p>
      </div>
    </div>

    <!-- arrows -->
    <template #prevArrow>
      <button type="button" class="slick-prev"><i class="fal fa-angle-left"></i></button>
    </template>

    <template #nextArrow>
      <button type="button" class="slick-next"><i class="fal fa-angle-right"></i></button>
    </template>
  </vue-slick-carousel>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel';

export default {
  name: 'CountrySnapshots',
  components: { VueSlickCarousel },
  props: {
    content: {
      type: Array,
      required: true,
    },
  },
  watch: {
    content: {
      handler() {
        this.$refs.carousel.goTo(0);
      },
      deep: true,
    },
  },
  data() {
    return {
      // UOB article-carousel slick settings
      slickSettings: {
        adaptiveHeight: true,
        arrows: true,
        autoplay: false,
        autoplaySpeed: 5000,
        dots: true,
        infinite: true,
        pauseOnHover: false,
        initialSlide: 0,
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.mt-15 {
  margin-top: 15px;
}

.wordcloud-carousel {
  .slick-arrow {
    color: #005eb8;
    text-shadow: 0 0 3px rgba(18, 18, 18, 0.12);

    &.slick-prev {
      left: -60px;
    }

    &.slick-next {
      right: -60px;
    }

    @media #{map-get($media-breakpoints, 'mobile')} {
      &.slick-prev {
        left: 0;
      }

      &.slick-next {
        right: 0;
      }
    }
  }

  ::v-deep .slick-dots {
    li {
      button {
        border: 3px solid #005eb8;
        background: #fff;
      }

      &.slick-active {
        button {
          border: 3px solid #e1091d !important;
          background: #e1091d;
        }
      }
    }
  }
}

::v-deep.slick-slide {
  .app-screenshot {
    display: flex;
    width: 100%;
    margin: 0 auto;

    &__caption {
      color: #1f1f1f;
      // font-style: italic;
    }

    footer {
      font-size: inherit;
      line-height: inherit;
      color: inherit;

      p {
        margin-bottom: 0;
      }
    }
  }
}

@media #{map-get($media-breakpoints, 'mobile')} {
  .content-country-snapshots__carousel {
    padding: 0 15px;
  }
}
</style>
